import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'ac-option-menu-item',
	templateUrl: './option-menu-item.component.html',
	styleUrls: ['./option-menu-item.component.scss']
})
export class OptionMenuItemComponent {
	@Input() public path: string = null;
	@Input() public classes: string | string[] = [];
	@Input() public activeClass: string = '';
	@Input() public icon: string = '';
	@Input() public linkEvent: string = null;
	@Input() public disabled: boolean = false;
	@Output() public onMenuItemClick: EventEmitter<any> = new EventEmitter<any>();
}
